import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Lock, ArrowRight } from "@phosphor-icons/react";
import adminApi from "../lib/adminApi";

export default function AdminReset() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setEmail(params.get("email") || "");
    setToken(params.get("token") || "");
  }, [params]);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd !== pwd2) {
      toast.error("Les mots de passe ne correspondent pas");
      return;
    }
    if (pwd.length < 8) {
      toast.error("Mot de passe trop court (min. 8 caractères)");
      return;
    }
    setLoading(true);
    try {
      const r = await adminApi.post("/password/reset", { email, token, new_password: pwd });
      localStorage.setItem("vita_admin_token", r.data.token);
      toast.success("Mot de passe réinitialisé. Bienvenue.");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Lien invalide ou expiré");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--paper)] flex items-center justify-center p-6" data-testid="admin-reset-page">
      <form onSubmit={submit} className="w-full max-w-md fade-up" data-testid="admin-reset-form">
        <div className="flex items-center gap-3 mb-8">
          <Lock weight="fill" size={28} className="text-[var(--signal)]" />
          <div>
            <div className="label-mono">§ Réinitialisation</div>
            <h1 className="font-serif text-3xl font-medium">Nouveau mot de passe</h1>
          </div>
        </div>
        <div className="space-y-4">
          <label className="block">
            <div className="label-mono mb-2">Email administrateur</div>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-black px-4 py-3"
              data-testid="admin-reset-email"
            />
          </label>
          <label className="block">
            <div className="label-mono mb-2">Token (préfilllé via le lien email)</div>
            <input
              type="text"
              required
              value={token}
              onChange={(e) => setToken(e.target.value)}
              className="w-full border border-black px-4 py-3 font-mono text-xs"
              data-testid="admin-reset-token"
            />
          </label>
          <label className="block">
            <div className="label-mono mb-2">Nouveau mot de passe</div>
            <input
              type="password"
              required
              minLength={8}
              value={pwd}
              onChange={(e) => setPwd(e.target.value)}
              className="w-full border border-black px-4 py-3"
              data-testid="admin-reset-pwd1"
            />
          </label>
          <label className="block">
            <div className="label-mono mb-2">Confirmation</div>
            <input
              type="password"
              required
              minLength={8}
              value={pwd2}
              onChange={(e) => setPwd2(e.target.value)}
              className="w-full border border-black px-4 py-3"
              data-testid="admin-reset-pwd2"
            />
          </label>
        </div>
        <button
          type="submit"
          disabled={loading}
          className="mt-6 w-full bg-[var(--signal)] hover:bg-[var(--signal-hover)] text-[var(--paper)] py-4 label-mono flex items-center justify-center gap-2 disabled:opacity-60"
          data-testid="admin-reset-submit"
        >
          {loading ? "Traitement..." : "Réinitialiser"}
          <ArrowRight size={16} weight="bold" />
        </button>
      </form>
    </div>
  );
}
